/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

const socialLibraryBucketSchema = z.object({
  clipCount: z.number(),
  isOverflowBucket: z.boolean(),
  eligible: z.number(),
  haveVideo: z.number(),
  missing: z.number(),
  isAboveThreshold: z.boolean(),
});

export type ISocialLibraryBucket = z.infer<typeof socialLibraryBucketSchema>;

const socialLibrarySummarySchema = z.object({
  eligible: z.number(),
  haveVideo: z.number(),
  missing: z.number(),
  poolTotal: z.number(),
  poolHaveVideo: z.number(),
  runwayDays: z.number(),
  coversDedupeWindow: z.boolean(),
});

export type ISocialLibrarySummary = z.infer<typeof socialLibrarySummarySchema>;

const libraryDataSchema = z.object({
  minClips: z.number(),
  buckets: z.array(socialLibraryBucketSchema),
  summary: socialLibrarySummarySchema,
});

export interface IGetSocialLibraryV1Data {
  minClips: number;
  buckets: ISocialLibraryBucket[];
  summary: ISocialLibrarySummary;
}

export const getSocialLibraryV1ResponseSchema = createApiResponseSchema(
  libraryDataSchema,
) as z.ZodSchema<IAPI<IGetSocialLibraryV1Data>>;

export type IGetSocialLibraryV1Response = IAPI<IGetSocialLibraryV1Data>;
